import React from "react";
import "../styles/team.css";

export const team = ({ data }) => {
  return (
    <>
      <section className="teamLandingPage">
        <h1>Meet the Team</h1>
      </section>
      <section className="teamIntro">
        <div className="teamWrap">
          {data.map(({ id, img, name, role }) => (
            <li key={id}>
              <div className="teamImg">
                <img src={img} alt="team Member" />
              </div>
              <div className="teamOverlay">
                <h3>{name}</h3>
                <p>{role}</p>
              </div>
            </li>
          ))}
        </div>
      </section>
      <section className="quote" id="teamQuote">
        <p>
          <sup>‘‘</sup>Thank you for being fantastic team members.<sub>’’</sub>
        </p>
      </section>
      <p className="quoteAuthor">Global Capability Director</p>
    </>
  );
};

export default team;
